import styled, { css } from 'styled-components';
import { SECONDARY_COLOR_6 } from '../../const/color';
import { FAMILY_FONT_CONTROL } from '../../const/text';

export const WrapContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const Container = styled(WrapContainer)`
  width: 16px;
  height: 16px;
`;

export const Layout = styled.div`
  position: fixed;
  z-index: 4;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
`;

export const Content = styled.div<{ active: boolean, offset: number, arrowOffset: number, width?: number, borderRadius?: number, top?: boolean, bottom?: boolean }>`
  position: absolute;
  display: ${props => props.active ? 'block' : 'none'};
  width: ${props => props.width ?? 320}px;
  box-sizing: content-box;
  z-index: 5;
  
  ${props => props.bottom ? css`
    top: calc(100% + 15px);
    left: ${props.offset}px;
  ` : ''}
  ${props => props.top ? css`
    bottom: calc(100% + 15px);
    left: ${props.offset}px;
  ` : ''}
  
  background: #FFFFFF;
  border: 1px solid ${SECONDARY_COLOR_6};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border-radius: ${props => props.borderRadius ?? 8}px;
  
  text-transform: initial;
  font-family: ${FAMILY_FONT_CONTROL};
  font-size: 12px;
  line-height: 160%;
  
  &:after {
    content: '';
    width: 10px;
    height: 10px;
    background-color: white;
    position:absolute;
    transform: rotate(45deg);
    left: ${props => props.arrowOffset}px;
    
    ${props => props.bottom ? css`
      border-top: 1px solid ${SECONDARY_COLOR_6};
      border-left: 1px solid ${SECONDARY_COLOR_6};
      left: ${props.arrowOffset + 8}px;
      top: -6px;  
    ` : ''}
    ${props => props.top ? css`
      border-bottom: 1px solid ${SECONDARY_COLOR_6};
      border-right: 1px solid ${SECONDARY_COLOR_6};
      left: ${props.arrowOffset - 8}px;
      bottom: -6px;
    ` : ''}
  }
`;